// // import React from "react";
// // import data2 from "../../../data/skills2.json";
// // import data from "../../../data/skills.json";
// // function Skills() {
// //   return (
// //     <div
// //       className="sec-box skills section-padding bord-thin-bottom"
// //       id="skills"
// //     >
// //       <div className="row">
// //         <div className="col-lg-4 valign">
// //           <div className="sec-head md-mb80 wow fadeIn">
// //             <h6 className="sub-title opacity-7 mb-15">Skills</h6>
// //             <h3>
// //               <span className="main-color">Experience</span> & Expertise
// //             </h3>
// //           </div>
// //         </div>
// //         <div className="col-lg-8">
// //           <div className="row">
// //             {data.map((item, index) => (
// //               <div key={index} className="col-md-6">
// //                 <div className="item mb-30">
// //                   <div className="d-flex align-items-center mb-30">
// //                     <div className="mr-30">
// //                       <div className="img icon-img-40">
// //                         <img src={item.photo} alt="" />
// //                       </div>
// //                     </div>
// //                     <div>
// //                       <h6 className="fz-18">{item.title}</h6>
// //                     </div>
// //                   </div>
// //                   <div className="skill-progress">
// //                     <span className="progres" data-value={item.persent}></span>
// //                   </div>
// //                   {/* <span className="value">{item.persent}</span> */}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Skills;

// import React from "react";
// import data from "../../../data/skills.json";

// function Skills() {
//   const experiences = [
//     {
//       role: "Full Stack Developer",
//       company: "Digital Ipsum Pvt. Ltd, Kolkata",
//       duration: "June 2022 – May 2025",
//       details: [
//         "Designed and developed scalable APIs and background workers using MERN stack.",
//         "Created custom full-stack solutions integrating MySQL with Node.js backend.",
//         "Developed responsive frontends with React.js ensuring smooth UI/UX.",
//         "Managed server deployments, maintenance, and issue resolution.",
//         "Delivered customized WordPress solutions with WooCommerce and Elementor.",
//       ],
//     },
//     {
//       role: "Frontend Developer",
//       company: "Digital Ipsum Pvt. Ltd, Kolkata",
//       duration: "Dec 2021 – Mar 2022",
//       details: [
//         "Built UI components with React.js and optimized SQL queries.",
//         "Contributed to backend API integrations using Node.js.",
//         "Customized WordPress themes and enhanced user experience.",
//       ],
//     },
//   ];

//   return (
//     <div className="sec-box section-padding bord-thin-bottom" id="skills">
//       {/* Skills Section */}
//       <div className="row">
//         <div className="col-lg-4 valign">
//           <div className="sec-head md-mb80 wow fadeIn">
//             <h6 className="sub-title opacity-7 mb-15">Skills</h6>
//             <h3>
//               <span className="main-color">Experience</span> & Expertise
//             </h3>
//           </div>
//         </div>
//         <div className="col-lg-8">
//           <div className="row">
//             {data.map((item, index) => (
//               <div key={index} className="col-md-6">
//                 <div className="item mb-30">
//                   <div className="d-flex align-items-center mb-30">
//                     <div className="mr-30">
//                       <div className="img icon-img-40">
//                         <img src={item.photo} alt={item.title} />
//                       </div>
//                     </div>
//                     <div>
//                       <h6 className="fz-18">{item.title}</h6>
//                     </div>
//                   </div>
//                   <div className="skill-progress">
//                     <span className="progres" data-value={item.persent}></span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Experience Section */}
//       <div className="row mt-100">
//         <div className="col-lg-4 valign">
//           <div className="sec-head md-mb80 wow fadeIn">
//             <h6 className="sub-title opacity-7 mb-15">Experience</h6>
//             <h3>
//               <span className="main-color">Career</span> Journey
//             </h3>
//           </div>
//         </div>
//         <div className="col-lg-8">
//           <div className="experience-timeline">
//             {experiences.map((exp, i) => (
//               <div key={i} className="exp-box mb-50 wow fadeInUp">
//                 <h5 className="fz-20 fw-600">{exp.role}</h5>
//                 <p className="opacity-8 mb-5">
//                   {exp.company} |{" "}
//                   <span className="main-color">{exp.duration}</span>
//                 </p>
//                 <ul className="list-disc ml-20 opacity-8">
//                   {exp.details.map((point, idx) => (
//                     <li key={idx}>{point}</li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Skills;

import React from "react";
import data from "../../../data/skills.json";

function Skills() {
  const experiences = [
    {
      role: "Freelance Developer",
      company: "Self-employed",
      duration: "July 2021 – Present",
      details: [
        "Delivered 10+ freelance projects for startups and businesses across industries.",
        "Built custom software solutions using the MERN stack (MongoDB, Express, React, Node.js).",
        "Developed modern e-commerce and corporate websites using Next.js and React.js.",
        "Created and customized WordPress sites with WooCommerce and Elementor.",
        "Handled domain registration, DNS configuration, and hosting management.",
        "Deployed and maintained projects on platforms like AWS, cPanel, and Vercel.",
        "Implemented responsive design and SEO best practices for client visibility.",
      ],
    },
    {
      role: "Full Stack Developer",
      company: "Digital Ipsum Pvt. Ltd, Kolkata",
      duration: "June 2022 – May 2025",
      details: [
        "Designed and developed scalable APIs and background workers using MERN stack.",
        "Created custom full-stack solutions with MySQL + Node.js backend integrations.",
        "Built responsive and dynamic frontends with React.js and Redux.",
        "Managed hosting, domain setup, and SSL integration for multiple client websites.",
        "Deployed apps and APIs using Linux servers for scalability.",
        "Diagnosed and fixed performance issues, improving stability and load times.",
        "Delivered customized WordPress solutions including theme development & WooCommerce.",
      ],
    },
    {
      role: "Frontend Developer",
      company: "Digital Ipsum Pvt. Ltd, Kolkata",
      duration: "Dec 2021 – Mar 2022",
      details: [
        "Assisted in building and maintaining React.js interfaces for production apps.",
        "Optimized SQL queries and supported backend API integrations.",
        "Customized WordPress UIs and enhanced client websites with Elementor.",
        "Worked on deployment tasks and helped configure hosting for smaller projects.",
        "Collaborated with backend team for bug fixing and system improvements.",
      ],
    },
  ];

  return (
    <div className="sec-box section-padding bord-thin-bottom" id="skills">
      {/* Skills Section */}
      <div className="row">
        <div className="col-lg-4 valign">
          <div className="sec-head md-mb80 wow fadeIn">
            <h6 className="sub-title opacity-7 mb-15">Skills</h6>
            <h3>
              <span className="main-color">Experience</span> & Expertise
            </h3>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="row">
            {data.map((item, index) => (
              <div key={index} className="col-md-6">
                <div className="item mb-30">
                  <div className="d-flex align-items-center mb-30">
                    <div className="mr-30">
                      <div className="img icon-img-40">
                        <img src={item.photo} alt={item.title} />
                      </div>
                    </div>
                    <div>
                      <h6 className="fz-18">{item.title}</h6>
                    </div>
                  </div>
                  <div className="skill-progress">
                    <span className="progres" data-value={item.persent}></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <div className="row mt-100" id="exp">
        <div className="col-lg-4 valign">
          <div className="sec-head md-mb80 wow fadeIn">
            <h6 className="sub-title opacity-7 mb-15">Experience</h6>
            <h3>
              <span className="main-color">Career</span> Journey
            </h3>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="experience-timeline relative">
            {experiences.map((exp, i) => (
              <div
                key={i}
                className="exp-box mb-50 wow fadeInUp relative pl-40"
              >
                {/* Timeline Dot */}
                <span className="timeline-dot"></span>
                {/* Timeline Line */}
                {i !== experiences.length - 1 && (
                  <span className="timeline-line"></span>
                )}

                <h5 className="fz-20 fw-600">{exp.role}</h5>
                <p className="opacity-8 mb-5">
                  {exp.company} |{" "}
                  <span className="main-color">{exp.duration}</span>
                </p>
                <ul className="list-disc ml-20 opacity-8">
                  {exp.details.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Custom CSS for timeline */}
      <style jsx>{`
        .experience-timeline {
          position: relative;
          padding-left: 20px;
        }
        .timeline-dot {
          position: absolute;
          left: 0;
          top: 8px;
          width: 12px;
          height: 12px;
          background: var(--main-color);
          border-radius: 50%;
        }
        .timeline-line {
          position: absolute;
          left: 5px;
          top: 25px;
          width: 2px;
          height: calc(100% - 20px);
          background: rgba(0, 0, 0, 0.1);
        }
        .exp-box {
          position: relative;
        }
      `}</style>
    </div>
  );
}

export default Skills;
